/* eslint no-constant-condition: "off" */

const d3 = require('d3')
const _ = {
  map: require('lodash/map'),
  uniqBy: require('lodash/uniqBy'),
  each: require('lodash/each'),
  orderBy: require('lodash/orderBy'),
}

const Radar = require('../models/radar')
const Quadrant = require('../models/quadrant')
const Ring = require('../models/ring')
const Blip = require('../models/blip')
const GraphingRadar = require('../graphing/radar')

// World Kinect (WK) - Radar view extensions
const publicationsView = require('../world-kinect/views/publications')
const emergingBlipsView = require('../world-kinect/views/emerging')
const moversBlipsView = require('../world-kinect/views/movers')
const coreBlipsView = require('../world-kinect/views/core')
const offRadarBlipsView = require('../world-kinect/views/offRadar')
const WorldKinectRadar = require('../world-kinect/views/radar')

const { getGraphSize, graphConfig } = require('../graphing/config')
const { worldKinectConfig } = require('../world-kinect/config')

function validateInputQuadrantOrRingName(allQuadrantsOrRings, quadrantOrRing) {
  const quadrantOrRingNames = Object.keys(allQuadrantsOrRings)
  const regexToFixLanguagesAndFrameworks = /(-|\s+)(and)(-|\s+)|\s*(&)\s*/g
  const formattedInputQuadrant = quadrantOrRing.toLowerCase().replace(regexToFixLanguagesAndFrameworks, ' & ')
  return quadrantOrRingNames.find((quadrantOrRing) => quadrantOrRing.toLowerCase() === formattedInputQuadrant)
}

const plotRadarGraph = function (title, blips, currentRadarName, alternativeRadars) {
  document.title = title.replace(/.(csv|json)$/, '')

  d3.selectAll('.loading').remove()

  const ringMap = graphConfig.rings.reduce((allRings, ring, index) => {
    allRings[ring] = new Ring(ring, index)
    return allRings
  }, {})

  const quadrants = graphConfig.quadrants.reduce((allQuadrants, quadrant) => {
    allQuadrants[quadrant] = new Quadrant(quadrant)
    return allQuadrants
  }, {})

  // Sort blips by quadrant, ring, and name
  blips = sortBlipsAlphabetically(blips)

  blips.forEach((blip) => {
    const currentQuadrant = validateInputQuadrantOrRingName(quadrants, blip.quadrant)
    const ring = validateInputQuadrantOrRingName(ringMap, blip.ring)
    if (currentQuadrant && ring) {
      const blipObj = new Blip(
        blip.name,
        ringMap[ring],
        blip.isNew.toLowerCase() === 'true',
        blip.topic,
        blip.description,
        blip.labels,
        blip.hasMovedIn.toLowerCase() === 'true',
        blip.hasMovedOut.toLowerCase() === 'true',
      )
      quadrants[currentQuadrant].add(blipObj)
    }
  })

  const radar = new Radar()
  radar.addRings(Object.values(ringMap))

  _.each(quadrants, function (quadrant) {
    radar.addQuadrant(quadrant)
  })

  alternativeRadars.forEach(function (sheetName) {
    radar.addAlternative(sheetName)
  })

  radar.setCurrentSheet(currentRadarName)

  const size = getGraphSize()
  new GraphingRadar(size, radar).init().plot()
}

const RadarBuilder = function () {
  var self = {}

  self.build = function () {
    emergingBlipsView()
    moversBlipsView()
    publicationsView()
    coreBlipsView()
    offRadarBlipsView()

    var searchParams = new URL(document.location).searchParams
    var publicationNameProvided = searchParams.has('publicationName')

    if (publicationNameProvided) {
      let publicationName = searchParams.get('publicationName')

      document.title = `${worldKinectConfig.title} | ${publicationName}`

      WorldKinectRadar()
        .init()
        .getPublicationBlips(publicationName)
        .then((res) => {
          plotRadarGraph(`${worldKinectConfig.title} | ${res.title}`, res.blips, 'Latest', [])
        })
    } else {
      document.title = worldKinectConfig.title
      WorldKinectRadar()
        .init()
        .getLatestBlips()
        .then((res) => {
          plotRadarGraph(`${worldKinectConfig.title} | ${res.title}`, res.blips, 'Latest', [])
        })
    }
  }

  return self
}

function sortBlipsAlphabetically(blips) {
  return _.orderBy(blips, [(blip) => blip.quadrant, (blip) => blip.ring, (blip) => blip.name.toLowerCase()])
}

module.exports = RadarBuilder
